import AddTransferTemplatePage, { getDefaultData } from "components/pages/AddTransferTemplatePage";
import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes from "model";

/**
 * @name CaptureAddTemplateMainDefaultAmountFilled
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMainDefaultAmountFilled(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template", "name" ], "Sample")
    .update([ "template", "fromAccount" ], "6")
    .update([ "template", "toAccount" ], "5")
    .update([ "template", "defaultAmount" ], "100")
    .submit();

    return <AddTransferTemplatePage data={ data }  />
}